<div class="container-fluid explore-page" id="explore_category">
  <div class="row breadcrumb-wrapper mt-5">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <app-breadcrumb *ngIf="showBreadCrumb"></app-breadcrumb>
          </div>
        </div>
      </div>
    </div>
  </div>
  <section class="banner-carousel">
    <div id="bannerCarousel" class="bannerCarousel position-relative">
      <img [src]='environment1 + "assets/images/Square-T-skyblue.png"' class="t-image" alt="T">

      <div class="horizontal-line"></div>

      <div class="vertical-line"></div>

      <div class="bottom-horizontal-line"></div>

      <div class="bottom-vertical-line"></div>
      <ng-container *ngIf="centerBanners.data?.length == 0 || !isLoading; else loadingContent">
        <ngx-skeleton height="730px"></ngx-skeleton>
      </ng-container>
      <ng-template #loadingContent>
        <owl-carousel-o [options]="customOptionsForBanner">
          <ng-container *ngFor="let data of centerBanners.data">
            <ng-template carouselSlide [id]="data?.id">
              <a (click)="GetTest(data)" (ngStyle)="{'cursor': data?.banner_link ? 'pointer ': 'not-allowed' }">
                <div class="top-banner-wrapper">
                  <img [src]="centerBanners?.cfrnt_url + data?.path" [alt]="data?.title" class="active" alt="banner_image" loading="lazy">
                </div>
              </a>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </ng-template>
    </div>
  </section>

  <div class="brand-videos pt-5 pb-2" *ngIf="videoData?.length != 0">
    <div class="container">
      <h1 class="page-sub-title cv-text-dark mb-4">Brand Videos</h1>
      <div class="row " [ngClass]="videoData?.length==1 ?'d-flex justify-content-center':''">
        <ng-container *ngIf="promotionalVideos?.length == 0 && !productLoaded;else productTemplate">
          <ng-container *ngFor="let item of skeletonService.generateFake(1);let i = index;">
            <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9 ps-xl-0"  >
              <div class="ratio ratio-16x9">
                <ngx-skeleton></ngx-skeleton>
              </div>
            </div>
          </ng-container>
          <ng-container>
            <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 position-relative overflow-hidden">
              <div class="scroll d-lg-grid gap-3">
                <ng-container *ngFor="let item of skeletonService.generateFake(5);let i = index;">
                  <div class="grid-item">
                    <div class="ratio ratio-16x9">
                      <ngx-skeleton height="150px"></ngx-skeleton>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <ng-template #productTemplate>
          <ng-container *ngFor="let item of videoData;let id = index">
            <div class=""[ngClass]="videoData?.length>=2 ? 'col-lg-9 col-xl-9' : 'col-lg-6 col-xl-6'" *ngIf="id==0" >
              <div class="ratio ratio-16x9">
                <ngx-lite-youtube [videoId]="getURL(item?.path)"></ngx-lite-youtube>
              </div>
            </div>
          </ng-container>
          <ng-container>

            <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 position-relative overflow-hidden"   [ngClass]="videoData?.length == 1 ? 'd-none' : 'd-block'"  *ngIf="videoData?.length!=0" >
              <div class="scroll d-lg-grid gap-3" #brandVideoDiv id="brandVideoDiv"     [ngClass]="videoData?.length >=5 ? 'brand-videos scroll2  ' : 'brand-videos scroll1'"     [ngClass]="videoData?.length ==4 ? 'brand-videos scroll3' : ''"  [ngClass]="videoData?.length==3 && !ismobile ?'brand-videos scroll4':'brand-videos scroll'"  >
                <ng-container *ngFor="let item of videoData;let id = index" >
                  <div class="grid-item" *ngIf="id != 0">
                    <div class="ratio ratio-16x9">
                      <ngx-lite-youtube [videoId]="getURL(item?.path)"></ngx-lite-youtube>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </ng-template>
      </div>
    </div>
  </div>



  <div class="browse-by-type" *ngIf="uniqueExploreBytype?.length == 0">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <h2>Browse By Type</h2>
        </div>
        <ng-container>
          <div class="browse-by-type">
            <div class="container">
              <div class="row ">
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6"
                  *ngFor="let item of skeletonService.generateFake(4);let i = index;">
                  <div class="box mb-3 d-flex flex-wrap">
                    <div class="img-wrapper col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3">
                      <ngx-skeleton height="150px" width="250px"></ngx-skeleton>
                    </div>
                    <div class="box-content col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                      <h3> <ngx-skeleton height="40px" width="300px"></ngx-skeleton></h3>
                      <div class="desc mb-3 text-ellipsis-2-line">
                        <ngx-skeleton height="30px" width="300px"></ngx-skeleton>
                      </div>
                      <div>
                        <a class="link-btn">
                          <ngx-skeleton height="30px" width="150px"></ngx-skeleton>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="browse-by-type" *ngIf="uniqueExploreByBrandList?.length > 0">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <h2>Browse By Type</h2>
        </div>
        <!-- <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6" *ngFor="let data of modifiedBrowseByType">
          <div class="box mb-4 d-flex flex-wrap cursor">
            <div class="img-wrapper mb-3 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6"
              (click)="onClickNewExplore(data,'Type',true)">
              <img alt="{{data?.browse_by_type_title}}" [src]="data?.browse_by_type_image" class="img-fluid" loading="lazy"/>
            </div>
            <div class="box-contetnt col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
              <h3>{{data?.browse_by_type_title}}</h3>
              <div *ngIf="data?.browse_by_type_description" class="desc mb-3 ">
                <div *ngIf="!data.showMore"> {{toggleDescription(data?.browse_by_type_description,80)}}</div>
                <div *ngIf="data.showMore"> {{data?.browse_by_type_description}} </div>
                <div *ngIf="data?.browse_by_type_description?.length> 20" (click)="data.showMore = !data.showMore"
                  class="showMoreLess">Show
                  <span>{{data.showMore ? 'less' :
                    'More'}}</span>
                </div>
              </div>
              <div>
                <a class="link-btn" (click)="onClickNewExplore(data,'Type',true)">
                  Explore
                  <img [src]="environment1 + 'images/new-images/rightArrowblue.svg'" alt="right Arrow" loading="lazy">
                </a>
              </div>
            </div>
          </div>
        </div> -->
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6" *ngFor="let data of uniqueExploreBytype">
          <div class="box mb-4 d-flex flex-wrap cursor">
            <div class="img-wrapper mb-3 col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6"
              (click)="onClickNewExplore(data,'Type',true)">
              <!-- <img alt="{{data?.browse_by_type}}" [src]="https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/Explore_type_images/{{data?.browse_by_type}}.webp" class="img-fluid" loading="lazy"/> -->
              <!-- <img alt="{{data?.browse_by_type}}" [src]="environment1 + 'Explore_brand_images/data?.browse_by_type.webp'" class="img-fluid" loading="lazy"/> -->
              <img
              [alt]="data?.browse_by_type"
              [src]="environment1 + 'Explore_type_images/' + replaceSpaces(data?.browse_by_type) + '.webp'"
              class="img-fluid"
              loading="lazy"
            />
            </div>
            <div class="box-contetnt col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
              <h3>{{data?.browse_by_type}}</h3>
              <div *ngIf="data?.type_title" class="desc mb-3 ">
                <div *ngIf="!data.showMore"> {{toggleDescription(data?.type_title,80)}}</div>
                <div *ngIf="data.showMore"> {{data?.type_title}} </div>
                <div *ngIf="data?.type_title?.length> 20" (click)="data.showMore = !data.showMore"
                  class="showMoreLess">Show
                  <span>{{data.showMore ? 'less' :
                    'More'}}</span>
                </div>
              </div>
              <div>
                <a class="link-btn" (click)="onClickNewExplore(data,'Type',true)">
                  Explore
                  <img [src]="environment1 + 'images/new-images/rightArrowblue.svg'" alt="right Arrow" loading="lazy">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!--Browse by modal design change due to new design-->
  <div class="browse-by-model" *ngIf="uniqueExploreByppl?.length == 0">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <h2 class="d-block d-md-flex">Browse By Model</h2>
        </div>
      </div>
      <div class="row g-4">
        <ng-container>
          <div class="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xx-3"
            *ngFor="let item of skeletonService.generateFake(4);let i = index;">
            <div class="flex-item">
              <div class="item d-block d-lg-flex align-items-center">
                <ngx-skeleton height="80px" width="240px"></ngx-skeleton>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="browse-by-model" *ngIf="uniqueExploreByppl?.length > 0">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <h2 class="d-block d-md-flex">Browse By Model</h2>
        </div>
      </div>
      <div class="row g-4">
        <div class="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xx-3" *ngFor="let data of uniqueExploreByppl">
          <div class="flex-item cursor" (click)="onClickArrowModel(data)">
            <div class="item d-block d-lg-flex align-items-center">
              <div class="icon me-3">
                <!-- <img [src]="data?.ppl_image_path" class="img-fluid cursor" alt="" loading="lazy"> -->
                <!-- <img alt="{{data?.browse_by_type}}" [src]="environment1 + 'Explore_brand_images/data?.browse_by_type.webp'" class="img-fluid" loading="lazy"/> -->
                <img
                [alt]="data?.ppl"
                [src]="environment1 + 'HeaderMenu/Icons/' + replaceSlashAndDot(data.ppl) + '.webp'"
                class="img-fluid"
                loading="lazy"
              />
              </div>
              <div class="item-content d-flex align-items-center w-100">
                <div class="ltr-content w-100 pe-3">
                  <h6 class="fw-bold mb-0 cursor">{{data?.ppl}}</h6>
                  <!-- <p class="mb-0">{{data?.display_description}}</p> -->
                </div>
                <div class="view-more d-none d-lg-block ms-auto">
                  <img [src]="environment1 + 'images/new-images/rightArrowdarkBlue.svg'" alt="right Arrow darkBlue" loading="lazy">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="explore-by-cabin-type" *ngIf="uniqueExploreByBrandList?.length == 0">
    <div class="container">
      <div class="row g-4">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <h2>Explore By Brand</h2>
        </div>

        <ng-container>
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
            *ngFor="let item of skeletonService.generateFake(3);let i = index;">
            <div class="box mb-3">
              <div class="img-wrapper mb-3">
                <ngx-skeleton height="150px" width="250px"></ngx-skeleton>
              </div>
              <h3><ngx-skeleton height="40px" width="300px"></ngx-skeleton></h3>
              <div class="desc mb-3 text-ellipsis-2-line">
                <ngx-skeleton height="30px" width="300px"></ngx-skeleton>
              </div>
              <div>
                <a class="link-btn">
                  <ngx-skeleton height="30px" width="150px"></ngx-skeleton>
                </a>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

    </div>
  </div>
  <!-- <div class="explore-by-cabin-type" *ngIf="modifiedExploreByType?.length > 0 && browseByTypeLoad">
    <div class="container">
      <div class="row g-4">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <h2>Explore By Brand</h2>
        </div>
        <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3" *ngFor="let data of modifiedExploreByType">
          <div class="box mb-3 cursor">
            <div class="img-wrapper mb-3" (click)="onClickNewExplore(data,'Brand',true)">
              <img alt="{{data?.explore_by_type_title}}" [src]="data?.explore_by_type_image" class="img-fluid" loading="lazy"/>
            </div>
            <h3 (click)="onClickNewExplore(data,'Brand',true)">{{data?.explore_by_type_title}}</h3>
            <div *ngIf="data?.explore_by_type_description" class="exp-c">
              <div *ngIf="!data.showMore"> {{toggleDescription(data?.explore_by_type_description,80)}}</div>
              <div *ngIf="data.showMore"> {{data?.explore_by_type_description}} </div>
              <div *ngIf="data?.explore_by_type_description?.length> 20" (click)="data.showMore = !data.showMore"
                class="showMoreLess">Show
                <span>{{data.showMore ? 'less' :
                  'More'}}</span>
              </div>
            </div>
            <div>
              <a class="link-btn" (click)="onClickNewExplore(data,'Brand',true)">
                Explore
                <img [src]="environment1 + 'images/new-images/rightArrowblue.svg'" alt="right Arrowblue" loading="lazy">
              </a>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div> -->

  <div class="explore-by-cabin-type" *ngIf="uniqueExploreByBrandList?.length > 0">
    <div class="container">
      <div class="row g-4">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <h2>Explore By Brand</h2>
        </div>
        <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3" *ngFor="let data of uniqueExploreByBrandList">
          <div class="box mb-3 cursor">
            <div class="img-wrapper mb-3" (click)="onClickNewExplore(data,'Brand',true)">
              <!-- <img alt="{{data?.explore_by_brand}}" [src]="https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/Explore_brand_images/{{data?.explore_by_brand}}.webp" class="img-fluid" loading="lazy"/> -->
              <!-- <img alt="{{data?.explore_by_brand}}" [src]="environment1 + 'Explore_brand_images/data?.explore_by_brand.webp'" class="img-fluid" loading="lazy"/> -->
              <img
              [alt]="data?.explore_by_brand"
              [src]="environment1 + 'Explore_brand_images/' + replaceSpacesexplore(data?.explore_by_brand) + '.webp'"
              class="img-fluid"
              loading="lazy"
            />
            </div>
            <h3 (click)="onClickNewExplore(data,'Brand',true)">{{data?.explore_by_brand}}</h3>
            <div *ngIf="data?.brand_title" class="exp-c">
              <div *ngIf="!data.showMore"> {{toggleDescription(data?.brand_title,80)}}</div>
              <div *ngIf="data.showMore"> {{data?.brand_title}} </div>
              <div *ngIf="data?.brand_title?.length> 20" (click)="data.showMore = !data.showMore"
                class="showMoreLess">Show
                <span>{{data.showMore ? 'less' :
                  'More'}}</span>
              </div>
            </div>
            <div>
              <a class="link-btn" (click)="onClickNewExplore(data,'Brand',true)">
                Explore
                <img [src]="environment1 + 'images/new-images/rightArrowblue.svg'" alt="right Arrowblue" loading="lazy">
              </a>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <div class="popular-vechicle" *ngIf="popularVehicleList?.length > 0">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <h2 class="d-flex align-items-center">Trending Products
            <a class="view-more cursor ms-auto" (click)="navigateToPLP('plp','')">View All</a>
          </h2>
        </div>
      </div>
      <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4">
        <div class="col" *ngFor="let row of popularVehicleList">
          <div class="poduct-item cursor">
            <div class="img-wrapper" >
              <img alt="" *ngIf="row.images[0].image_url" src="{{row.images[0].image_url}}" class="img-fluid" loading="lazy" (click)="openProduct(row)">
              <img alt="" *ngIf="!row.images[0].image_url" [src]='environment1 + "assets/images/default_vehicle_img.webp"'
                class="img-fluid" loading="lazy">
              <div class="d-flex align-items-center tagf">
                <span class="badge bg-primary"> Trending Products </span>
                <div class="like ms-auto">
                  <button class="btn-style"
                    (click)="clickToAddWishlist(row.id)">
                    <span *ngIf="!row.wishlist">
                      <img [src]="environment1 + 'images/new-images/heart.svg'" alt="heart" loading="lazy">
                    </span>
                    <span *ngIf="row.wishlist">
                      <img [src]="environment1 + 'images/new-images/fillHeart.svg'" alt="fill heart" loading="lazy">
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <div class="cv-name text-ellipsis cursor" (click)="openProduct(row)">
              {{row?.model}}
            </div>
            <div class="price ">
              {{row?.price_range| currency:'INR':'symbol':'4.0-0'}} <span class="ex-show ps-1">Ex-showroom </span>
            </div>
            <div class="rating">
              <ngx-stars [readonly]="true" [customStarIcons]="heartUrls" [color]="'#FDC602'" [initialStars]="row.rating"
                [size]="5"></ngx-stars>
            </div>

            <div class="book-now">
              <button type="button" class="btn btn-primary text-ellipsis btn-lg btn-grad-primary btn-brand w-100"
                (click)="bookNow(row)"  data-toggle="tooltip" data-placement="top" title="Click here for Booking"
                >Book Now at {{row.down_payment |
                currency:'INR':'symbol':'4.0-0'}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
